module.exports = __webpack_public_path__ + "img/mind.9df68661.svg";